import { useRef, useState } from 'react'

import { BIRDVIEW_ATTENTION_DEFAULT_AGE } from '../../../DashboardBirdview.constants.attention'
import {
  checkIsBirdviewAttentionDefaultAge,
  getBirdviewSectionState,
} from '../../../DashboardBirdview.utils'

export function useBirdviewAttentionAge({ group, onLoadGroup }) {
  const [age, setAge] = useState(BIRDVIEW_ATTENTION_DEFAULT_AGE)
  const [filtered, setFiltered] = useState(null)
  const [hasError, setHasError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const latestAgeRef = useRef(age)

  function loadBucket(option) {
    setIsLoading(true)
    setHasError(false)

    onLoadGroup({ age: option, group: group.key })
      .then(section => {
        if (latestAgeRef.current === option) {
          setFiltered(section)
          setIsLoading(false)
        }
      })
      .catch(() => {
        if (latestAgeRef.current === option) {
          setFiltered(null)
          setHasError(true)
          setIsLoading(false)
        }
      })
  }

  function handleSelectAge(option) {
    latestAgeRef.current = option
    setAge(option)

    if (checkIsBirdviewAttentionDefaultAge(option)) {
      setFiltered(null)
      setHasError(false)
      setIsLoading(false)
    } else {
      loadBucket(option)
    }
  }

  function handleRetry() {
    loadBucket(age)
  }

  const items = filtered?.items ?? group.items

  return {
    age,
    count: filtered?.total ?? group.count,
    extra: filtered?.extra ?? group.extra,
    handleRetry,
    handleSelectAge,
    items,
    state: getBirdviewSectionState({ hasError, isLoading, items }),
  }
}
